import React from "react";
import "./sectionContent.scss";
import CommonCta from "../CommonCta/CommonCta";
import { useWindowSize } from "react-use";

const SectionContent = ({
  title,
  h1Tag,
  description,
  ctaText,
  ctaLink,
  titleColor,
  descColor,
}) => {
  const { width } = useWindowSize();

  return (
    <>
      <div className="row section_row">
        <div className="col-lg-6 section_col">
          <div className="content_wrapper">
            {title &&
              (h1Tag ? (
                <h1
                  className="section_heading100"
                  style={{ color: titleColor }}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              ) : (
                <h2
                  className="section_heading100"
                  style={{ color: titleColor }}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              ))}
            {width > 991 && ctaText && (
              <CommonCta text={ctaText} link={ctaLink} linkCta={true} />
            )}
          </div>
        </div>
        <div className="col-lg-6 section_col">
          {description && (
            <div className="content_wrapper">
              <p
                className="section_desc22"
                style={{ color: descColor }}
                dangerouslySetInnerHTML={{ __html: description }}
              ></p>
            </div>
          )}
          {width <= 991 && ctaText && (
            <CommonCta text={ctaText} link={ctaLink} linkCta={true} />
          )}
        </div>
      </div>
    </>
  );
};

export default SectionContent;
